// @ts-nocheck
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    CalculateTotal as baseCalculateTotal,
    chain,
} from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/CalculateTotal";
import getSampleProductInfoIfNeeded from "@store/Framework/Common/Utilities/samples/getSampleProductInfoIfNeeded";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const CalculateTotal = createChainHandler("CalculateTotal", chain, props => {
    /* Store Custom Code - Start */
    const state = props.getState();

    const productInfos = state.pages.quickOrder.productInfos.map(x => {
        const product = getProductState(state, x.productId).value;
        return product ? getSampleProductInfoIfNeeded(state, product, x) || x : x;
    });
    /* Store Custom Code - End */

    let total = 0;
    productInfos.forEach(o => /* Store Custom Code */ {
        total += o.pricing?.extendedUnitNetPrice || 0;
    });
    props.result = total;
});

replaceInChain(chain, baseCalculateTotal, CalculateTotal);
